import {
  Field,
  ImageField,
  NextImage as JssImage,
  Link as JssLink,
  LinkField,
  Text,
  useSitecore,
} from '@sitecore-content-sdk/nextjs';
import React, { JSX, CSSProperties } from 'react';

interface Fields {
  Image: ImageField & { metadata?: { [key: string]: unknown } };
  ImageCaption: Field<string>;
  TargetUrl: LinkField;
}

type ImageProps = {
  params: { [key: string]: string };
  fields: Fields;
};

const ImageDefault = (props: ImageProps): JSX.Element => (
  <div className={`component image ${props?.params?.styles}`.trimEnd()}>
    <div className="component-content">
      <span className="is-empty-hint">Image</span>
    </div>
  </div>
);

export const Banner = (props: ImageProps): JSX.Element => {
  const id = props.params.RenderingIdentifier;
  const { page } = useSitecore();
  const isPageEditing = page.mode.isEditing;
  const isMetadataMode = page?.mode?.isEditing;
  const image = props?.fields?.Image?.value;
  const classHeroBannerEmpty =
    isPageEditing && image?.class === 'scEmptyImage' ? 'hero-banner-empty' : '';
  const backgroundStyle = (image?.src && {
    backgroundImage: `url('${image.src}')`,
  }) as CSSProperties;
  const modifyImageProps = !isMetadataMode
    ? {
        ...props.fields.Image,
        editable: image?.src
          ?.replace(`width="${image?.width}"`, 'width="100%"')
          .replace(`height="${image?.height}"`, 'height="100%"'),
      }
    : {
        ...props.fields.Image,
        value: {
          ...image,
          style: { width: '100%', height: '100%' },
        },
      };

  return (
    <div
      className={`component hero-banner ${props?.params?.styles} ${classHeroBannerEmpty}`}
      id={id ? id : undefined}
    >
      <div className="component-content sc-sxa-image-hero-banner" style={backgroundStyle}>
        {page.mode.isEditing ? <JssImage field={modifyImageProps} /> : ''}
      </div>
    </div>
  );
};

export const Default = (props: ImageProps): JSX.Element => {
  const { page } = useSitecore();

  if (props.fields) {
    const Image = () => <JssImage field={props.fields.Image} />;
    const id = props.params.RenderingIdentifier;

    return (
      <div className={`component image ${props?.params?.styles}`} id={id ? id : undefined}>
        <div className="component-content">
          {page?.mode?.isEditing || !props.fields.TargetUrl?.value?.href ? (
            <Image />
          ) : (
            <JssLink field={props.fields.TargetUrl}>
              <Image />
            </JssLink>
          )}
          <Text
            tag="span"
            className="image-caption field-imagecaption"
            field={props.fields.ImageCaption}
          />
        </div>
      </div>
    );
  }

  return <ImageDefault {...props} />;
};
